<template>
    <default-template>
        <div class="background-content">
            <v-container>
                <slot />
            </v-container>
        </div>
    </default-template>
</template>
<script>
import DefaultTemplate from "../DefaultTemplate.vue";
export default {
    components: {
        DefaultTemplate
    }
}
</script>
<style scoped>
.background-content {
    margin:-30px 0;
    background-image: url('/images/login-bg.png');
    background-repeat: no-repeat;
    background-position:center;
    background-size: cover;
    background-color: #f1f2f7;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .background-content {
        margin:-40px 0;
    }
}
@media (min-width:1024px){
    .background-content {
        margin:-50px 0;
    }
}
@media (min-width:1200px){
}
</style>